var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVechicleTypebased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 16.4445V16.4445C4.79594 16.4445 4 15.6486 4 14.6667V6.66672C4 6.43097 4.09365 6.20488 4.26035 6.03818C4.42705 5.87148 4.65314 5.77783 4.88889 5.77783H9.88889C11.5457 5.77783 12.8889 7.12098 12.8889 8.77783V16.4445M9.33333 16.4445H14.6667M18.2222 16.4445V16.4445C19.2041 16.4445 20 15.6486 20 14.6667V11.1112M20 11.1112H12.8889M20 11.1112L18.2072 8.12323C17.6651 7.21962 16.6886 6.66672 15.6348 6.66672H12.8889",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77783 16.4443C5.77783 16.9158 5.96513 17.368 6.29853 17.7014C6.63193 18.0348 7.08411 18.2221 7.55561 18.2221C8.02711 18.2221 8.47929 18.0348 8.81269 17.7014C9.14609 17.368 9.33339 16.9158 9.33339 16.4443C9.33339 15.9728 9.14609 15.5206 8.81269 15.1872C8.47929 14.8538 8.02711 14.6665 7.55561 14.6665C7.08411 14.6665 6.63193 14.8538 6.29853 15.1872C5.96513 15.5206 5.77783 15.9728 5.77783 16.4443Z",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 16.4443C14.6666 16.9158 14.8539 17.368 15.1873 17.7014C15.5207 18.0348 15.9729 18.2221 16.4444 18.2221C16.9159 18.2221 17.3681 18.0348 17.7015 17.7014C18.0349 17.368 18.2222 16.9158 18.2222 16.4443C18.2222 15.9728 18.0349 15.5206 17.7015 15.1872C17.3681 14.8538 16.9159 14.6665 16.4444 14.6665C15.9729 14.6665 15.5207 14.8538 15.1873 15.1872C14.8539 15.5206 14.6666 15.9728 14.6666 16.4443Z",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVechicleTypebased);
export default __webpack_public_path__ + "static/media/VechicleTypebased.c85377c55ad4bacaccec2c4dc1a21277.svg";
export { ForwardRef as ReactComponent };